import type { BankData } from "../../service/forms/config-generics/bank-details";
import type { SVGProcessData, SVGSourceData } from "./svg-config";

export function getBankSVGLines(data: BankData): SVGProcessData {
    const {
        bank,
        bankAccountCountry,
        overseasBankCountry,
        overseasBankAddress,
        overseasBankName,
        overseasBankNumber,
        overseasBankSwift,
        bankVerification,
    } = data;

    if (!bankAccountCountry) {
        return {
            svgLines: [],
            remainingData: (data as unknown) as SVGSourceData,
        };
    }

    let svgLines;

    if (bankAccountCountry === "Aotearoa") {
        const { name, bank: bankBank, branch, account, suffix } = bank;
        svgLines = [
            { heading: "Pēke - Bank" },
            { label: "Name", text: name },
            {
                label: "Number",
                text: `${bankBank} ${branch} ${account} ${suffix}`,
            },
            { label: "Verification", text: bankVerification[0].name },
        ];
    } else {
        svgLines = [
            { heading: "Pēke Tāwāhi - Overseas Bank" },
            { label: "Country", text: overseasBankCountry },
            { label: "Address", text: overseasBankAddress },
            { label: "Name", text: overseasBankName },
            { label: "Number", text: overseasBankNumber },
            { label: "Swift", text: overseasBankSwift },
            { label: "Verification", text: bankVerification[0].name },
        ];
    }

    const {
        bank: _bank,
        bankAccountCountry: _bankAccountCountry,
        overseasBankCountry: _overseasBankCountry,
        overseasBankAddress: _overseasBankAddress,
        overseasBankName: _overseasBankName,
        overseasBankNumber: _overseasBankNumber,
        overseasBankSwift: _overseasBankSwift,
        bankVerification: _bankVerification,
        ...remainingData
    } = data;

    return {
        svgLines,
        remainingData: (remainingData as unknown) as SVGSourceData,
    };
}
